/* «Noch ein Tuch dazu» – Aufstock-Zeile im Warenkorb, 24.08.2026.
   Konfiguration und Zeilenvorlage: snippets/tuki-tuch-aufstocken.liquid (dort
   steht auch die Fachlogik samt Begruendung). Farben, Bundle-Varianten und der
   Bestickungstext kommen aus window.TukiTuch.cfg
   (snippets/tuki-tuch-menge.liquid). */
(function () {
  'use strict';
  if (window.__tukiUpInit) return;
  window.__tukiUpInit = true;

  var raw = document.getElementById('tuki-up-data');
  if (!raw) return;
  var UP;
  try { UP = JSON.parse(raw.textContent); } catch (e) { return; }

  var cart = null, lastFetch = 0, busy = false;

  function root() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (r || '/').replace(/\/$/, '');
  }

  function post(url, data) {
    return fetch(root() + url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(new Error(url)); });
  }

  function getCart(force) {
    var now = Date.now();
    if (!force && cart && now - lastFetch < 1200) return Promise.resolve(cart);
    lastFetch = now;
    return fetch(root() + '/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; return c; });
  }

  function slug(v) { return String(v || '').toLowerCase().trim().replace(/\s+/g, '-'); }

  /* Ist der Handle ein Einzeltuch? Das Sammelprodukt UND die vier Farbseiten
     zaehlen – siehe die Begruendung im Snippet. UP.singles kann in aelteren
     Staenden fehlen, deshalb der Rueckfall auf den einen bekannten Handle. */
  function isSingle(h) {
    if (UP.singles) return Object.prototype.hasOwnProperty.call(UP.singles, h);
    return h === UP.handles.single;
  }

  function perOf(h) {
    if (isSingle(h)) return 1;
    if (h === UP.handles.duo) return 2;
    if (h === UP.handles.trio) return 3;
    return 0;
  }

  /* Welche Farben stecken in dieser Position?
     Farbseiten tragen die Farbe im Handle (UP.singles[handle] ist dann ein
     Wert), alle anderen im Variantentitel «Sage / Glacier». */
  function slugsOf(item) {
    var fixed = UP.singles && UP.singles[item.handle];
    if (fixed) return [fixed];
    return String(item.variant_title || '').split(' / ').map(slug).filter(Boolean);
  }

  function engravedName(item) {
    var p = item && item.properties;
    if (!p) return '';
    return String(p._personalization_text || p.Personalisierung || '').trim();
  }

  function clothCount(c) {
    if (!c || !c.items) return 0;
    var n = 0;
    c.items.forEach(function (it) { n += perOf(it.handle) * it.quantity; });
    return n;
  }

  /* Was gibt der Warenkorb her? null = kein Angebot.
     Dass der Zubehoer-Block daneben nicht zusaetzlich das Einzeltuch empfiehlt,
     regelt zum einen acc_tuch_included_in in snippets/tuki-accessories.liquid,
     zum anderen dropDoubleCloth() weiter unten. */
  function offer(c) {
    if (!c || !c.items) return null;
    var lines = [], hasSet = false;
    c.items.forEach(function (it) {
      if (UP.handles.sets.indexOf(it.handle) > -1) hasSet = true;
      var per = perOf(it.handle);
      if (per) lines.push({ item: it, per: per });
    });
    if (hasSet) return null;
    if (clothCount(c) >= 3) return null;
    if (lines.length !== 1) return null;
    var l = lines[0];
    if (l.item.quantity !== 1) return null;
    if (l.per !== 1 && l.per !== 2) return null;
    if (!UP.price[String(l.per + 1)]) return null;
    /* Ohne erkennbare Farbe liesse sich keine Bundle-Variante bestimmen. */
    if (slugsOf(l.item).length !== l.per) return null;
    return { line: l.item, per: l.per, n: l.per + 1, oldName: engravedName(l.item) };
  }

  function colours() { return (window.TukiTuch && window.TukiTuch.cfg.colours) || []; }

  function targetVariant(o, newSlug) {
    var cfg = window.TukiTuch && window.TukiTuch.cfg;
    if (!cfg) return 0;
    var have = slugsOf(o.line);
    var key = have.concat([newSlug]).sort().join('|');
    var set = cfg.sets[String(o.n)];
    return (set && set.map && set.map[key]) || 0;
  }

  function swatchHtml(sel) {
    return colours().map(function (c) {
      return '<button type="button" class="tuki-tm__sw" data-slug="' + c.slug + '" title="' + c.title +
        '" aria-pressed="' + (c.slug === sel) + '" style="background-image:url(' + c.swatch + ')">' +
        '<span class="visually-hidden">' + c.title + '</span></button>';
    }).join('');
  }

  /* ⚠️ Nur zeichnen, wenn sich wirklich etwas geaendert hat. paint() laeuft aus
     dem scan()-Hook von window.TukiTuch, und der haengt an einem
     MutationObserver: wuerde hier bei jedem Durchlauf DOM geschrieben, loeste
     das sofort den naechsten scan() aus – eine Endlosschleife, die obendrein
     Klicks verschluckt, weil die Swatches staendig neu gebaut werden. */
  function paint(row) {
    var st = row._up, n = st.offer.n, old = st.offer.oldName;
    var sig = n + '|' + st.slug + '|' + old;
    if (st.sig === sig) return;
    st.sig = sig;
    row.querySelector('.tuki-acc__name').textContent = UP.name[String(n)];
    row.querySelector('.tuki-acc__price-now').textContent = UP.price[String(n)];
    row.querySelector('.tuki-up__old').textContent = UP.compare;
    row.querySelector('.tuki-acc__save').textContent = UP.save[String(n)] + ' ' + UP.saved;
    row.querySelector('.tuki-tm__sws').innerHTML = swatchHtml(st.slug);
    var img = row.querySelector('.tuki-acc__img');
    var src = (UP.img && UP.img[st.slug]) || '';
    if (img && src) img.setAttribute('src', src);

    /* Bestickung: liegt schon ein bestickter Tuchposten im Warenkorb, kommt
       derselbe Name zwingend auch auf das neue Tuch – der Name haengt an der
       Bundle-Position, «zwei von drei bestickt» gibt es nicht. Dann kostet es
       nur EINEN Stickpreis mehr, nicht n. Ohne bestehende Bestickung gilt das
       normale Angebot fuer alle n Tuecher. */
    var toggle = row.querySelector('.tuki-acc__pers-toggle span');
    var check = row.querySelector('.tuki-acc__pers-check');
    var field = row.querySelector('.tuki-acc__pers-name');
    if (toggle) {
      if (old) {
        if (check) { check.checked = true; check.disabled = true; }
        if (field) { field.value = old; field.hidden = true; }
        toggle.textContent = UP.engraveKeep.replace('{name}', old) +
          ' (+ ' + (UP.pers['1'] || '') + ')';
      } else {
        if (check) check.disabled = false;
        var txt = window.TukiTuch && window.TukiTuch.cfg.text;
        var lbl = txt && txt.engraveAll ? txt.engraveAll.replace('{n}', n) : UP.engrave;
        toggle.textContent = lbl + ' (+ ' + (UP.pers[String(n)] || '') + ')';
      }
    }
  }

  function nameOf(row) {
    var check = row.querySelector('.tuki-acc__pers-check');
    if (!check || !check.checked) return '';
    var f = row.querySelector('.tuki-acc__pers-name');
    return f ? (f.value || '').trim() : '';
  }

  function repaint() {
    return fetch(root() + '/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var doc = new DOMParser().parseFromString(d['cart-drawer'] || '', 'text/html');
        var fresh = doc.querySelector('#CartDrawer .drawer__inner') || doc.querySelector('.drawer__inner');
        var cur = document.querySelector('#CartDrawer .drawer__inner');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        var dr = document.querySelector('cart-drawer');
        if (dr) dr.classList.remove('is-empty');
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && d['cart-icon-bubble']) {
          var bd = new DOMParser().parseFromString(d['cart-icon-bubble'], 'text/html');
          var nb = bd.getElementById('cart-icon-bubble');
          if (nb) bubble.innerHTML = nb.innerHTML;
        }
      })
      .catch(function () {});
  }

  /* Tausch: neue Bundle-Position REIN, danach die alte raus.
     ⚠️ Reihenfolge ist Absicht. Umgekehrt (erst loeschen) stand der Kunde bei
     einem Fehler im zweiten Schritt ohne Tuch da – genau das ist am 24.08. im
     Test passiert. So bleibt im schlimmsten Fall beides im Warenkorb: sichtbar
     und selbst korrigierbar.

     Die Gravurzeilen werden anschliessend exakt nachgefuehrt – nie pauschal
     gesetzt, sie koennen auch zu anderen Positionen gehoeren:
       gleicher Name  -> bestehende Zeile um (n - per) erhoehen
       anderer Name   -> alte Zeile um per senken, neue mit n anlegen
       keine Gravur   -> alte Zeile um per senken */
  function upgrade(row) {
    if (busy) return;
    var btn = row.querySelector('.tuki-acc__add');
    busy = true;
    if (btn) btn.classList.add('is-loading');

    getCart(true).then(function (c) {
      var o = offer(c);
      if (!o) throw new Error('kein Angebot mehr');
      var target = targetVariant(o, row._up.slug);
      if (!target) throw new Error('keine Variante');

      var oldName = o.oldName;
      var newName = nameOf(row) || oldName;
      var props = newName ? { Personalisierung: newName, _personalization_text: newName } : {};

      return post('/cart/add.js', { items: [{ id: target, quantity: 1, properties: props }] })
        .then(function () { return post('/cart/change.js', { id: o.line.key, quantity: 0 }); })
        .then(function () { return getCart(true); })
        .then(function (c2) {
          var persLines = c2.items.filter(function (i) { return i.handle === UP.handles.pers; });
          function lineFor(name) {
            return persLines.filter(function (i) {
              return engravedName(i) === name || (i.properties && i.properties.Bestickungsname === name);
            })[0];
          }
          if (oldName && newName === oldName) {
            var same = lineFor(oldName);
            var d = o.n - o.per;
            if (!d) return null;
            if (same) return post('/cart/change.js', { id: same.key, quantity: Math.max(0, same.quantity + d) });
            return post('/cart/add.js', { items: [{ id: UP.persVariant, quantity: o.n,
              properties: { _personalization_text: newName, Bestickungsname: newName } }] });
          }
          var chain = Promise.resolve();
          if (oldName) {
            var lo = lineFor(oldName);
            if (lo) chain = chain.then(function () {
              return post('/cart/change.js', { id: lo.key, quantity: Math.max(0, lo.quantity - o.per) });
            });
          }
          if (newName) chain = chain.then(function () {
            return post('/cart/add.js', { items: [{ id: UP.persVariant, quantity: o.n,
              properties: { _personalization_text: newName, Bestickungsname: newName } }] });
          });
          return chain;
        });
    })
      .then(function () { cart = null; return repaint(); })
      .catch(function () { cart = null; return repaint(); })
      .then(function () {
        busy = false;
        if (btn) btn.classList.remove('is-loading');
        if (window.TukiTuch) window.TukiTuch.scan();
      });
  }

  /* Zwei Tuchzeilen uebereinander verhindern.
     Der Zubehoer-Block kennt das Tuch ueber Handles. Faellt dort eine Farbseite
     durch, haelt er das Tuch fuer fehlend und empfiehlt es zu 79 – direkt
     neben unserem Angebot fuer 40. Wo wir aufstocken, hat die Einzeltuch-Zeile
     nichts mehr zu suchen; also raus damit.
     Erkannt wird sie daran, dass ALLE ihre Optionen Tuchfarben sind (sage,
     glacier, dark-olive, sand) – die Lernturm-Zeile daneben fuehrt Holzfarben
     und bleibt unberuehrt. Auf die Options-Werte ist kein Verlass: die
     Mengenleiter schreibt sie auf Duo-/Trio-IDs um. */
  function dropDoubleCloth(list) {
    var cfg = window.TukiTuch && window.TukiTuch.cfg;
    if (!cfg || !cfg.single || !cfg.single.map) return;
    Array.prototype.forEach.call(list.querySelectorAll('.tuki-acc__row'), function (r) {
      if (r.hasAttribute('data-tuki-up')) return;
      var sel = r.querySelector('.tuki-acc__variant');
      if (!sel || !sel.options.length) return;
      var allCloth = Array.prototype.every.call(sel.options, function (o) {
        var s = o.getAttribute('data-slug');
        return s && cfg.single.map[s];
      });
      if (allCloth) r.remove();
    });
  }

  /* ---------- Ein- und Ausblenden ---------- */
  function sync() {
    var tpl = document.getElementById('tuki-up-tpl');
    if (!tpl) return;
    getCart(false).then(function (c) {
      var o = offer(c);
      document.querySelectorAll('.tuki-acc[data-tuki-acc-mode="cart"]').forEach(function (block) {
        var list = block.querySelector('.tuki-acc__list');
        if (!list) return;
        var row = list.querySelector('[data-tuki-up]');
        if (!o) { if (row) row.remove(); return; }
        if (!row) {
          row = tpl.content.cloneNode(true).firstElementChild;
          list.insertBefore(row, list.firstElementChild);
          /* ⚠️ Auf Mobile ist die Liste ein Slider mit scroll-snap
             (snippets/tuki-acc-slider.liquid). Wird vorne eine Karte
             eingefuegt, rastet der Browser wieder auf die zuvor eingerastete
             Karte ein und schiebt die neue aus dem Bild – ausgerechnet die,
             die den Anlass fuer den ganzen Block liefert. Gemessen am
             25.08.: scrollLeft sprang auf exakt eine Kartenbreite.
             Deshalb zurueck an den Anfang. */
          list.scrollLeft = 0;
        }
        dropDoubleCloth(list);
        if (!row._up) row._up = { offer: o, slug: colours()[0] ? colours()[0].slug : '' };
        row._up.offer = o;
        paint(row);
      });
    }).catch(function () {});
  }

  /* Capture-Phase: assets/tuki-accessories.js faengt Klicks auf
     .tuki-acc__add ebenfalls im Capture ab und ruft stopPropagation() – ein
     Listener in der Bubble-Phase wuerde nie laufen. Auf demselben Knoten
     (document) laufen beide Capture-Listener. Der dortige Handler steigt bei
     unserer Zeile folgenlos aus, weil sie keine Varianten-ID traegt. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var row;
    var sw = e.target.closest('.tuki-tm__sw');
    if (sw) {
      row = sw.closest('[data-tuki-up]');
      if (row && row._up) { e.preventDefault(); row._up.slug = sw.getAttribute('data-slug'); paint(row); }
      return;
    }
    var add = e.target.closest('.tuki-acc__add');
    if (add) {
      row = add.closest('[data-tuki-up]');
      if (row && row._up) { e.preventDefault(); upgrade(row); }
    }
  }, true);

  function boot() {
    if (!window.TukiTuch) { setTimeout(boot, 200); return; }
    window.TukiTuch.hooks.push(sync);
    window.TukiTuch.scan();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
